import { Bounds } from "../geometry.bounds";
import { Cartesian2, Cartesian3 } from "../geometry.cartesian";
import { isCartesian } from "../geometry.interfaces";
import { AbstractShape } from "./geometry.shape";
import { ShapeType } from "./geometry.shapes.interfaces";
export class Point extends AbstractShape {
    constructor(a, b, c) {
        super(ShapeType.Point);
        if (isCartesian(a)) {
            this._position = a;
        }
        else {
            this._position = new Cartesian3(a, b ?? 0, c ?? 0);
        }
    }
    get position() {
        return this._position;
    }
    set position(v) {
        if (Cartesian3.Equals(v, this._position) == false) {
            this._position = v;
            this.invalidateBounds();
        }
    }
    clip(clipArea) {
        let code = Cartesian2.ComputeCode(this._position, clipArea);
        if (code == 0) {
            return this;
        }
        return undefined;
    }
    _buildBounds() {
        return Bounds.FromPoints2(this._position);
    }
    _getPoints() {
        return [this._position];
    }
}
//# sourceMappingURL=geometry.point.js.map